/* utils/snapToZones.ts
   ---------------------------------------------------------------
   Snap a react-grid-layout item into one of three zones:

   ┌────────────── 9 columns (0 – 8) ───────────────┐
   │ Left zone │     middle (forbidden)    │ Right │
   │ x 0 , w 5 │          —                 │ x 5 , w 4 │
   │ cols 0-4  │          —                 │ cols 5-8  │
   │  (full-width ⇒ x 0 , w 9)                           │
   └──────────────────────────────────────────────────────┘
*/
import {Layout} from 'react-grid-layout';

export function reduxSnapItem(i: Layout): Layout {
  /* -------- full-width stays full-width -------- */
  if (i.w === 9) return {...i, x: 0, w: 9};

  /* Decide by the **centre** of the item so that even a
     4-col item that has only 1-px overlap with the left
     half is treated as “left” and vice-versa.             */
  const centre = i.x + i.w / 2; // ⟷ grid units (0 – 9)

  /* ≤ 4.5  ⇒ clearly in left half → snap hard-left */
  if (centre <= 4.5) return {...i, x: 0, w: 5};

  /* > 4.5 ⇒ right half → snap hard-right             */
  return {...i, x: 5, w: 4};
}
